export const marvel = "https://www.marvel.com/";
export const privacy =
  "https://privacy.thewaltdisneycompany.com/en/current-privacy-policy/";
export const terms = `https://disneytermsofuse.com/english-united-kingdom/`;
export const license = "https://www.marvel.com/corporate/license_tou";
export const cookie =
  "https://privacy.thewaltdisneycompany.com/en/current-privacy-policy/cookies-policy";
export const facebookLink = "http://facebook.com/marvel";
export const instagramLink = "http://instagram.com/marvel";
export const twitterLink = "http://twitter.com/marvel";
export const tumblrLink = "http://marvelentertainment.tumblr.com/";
export const youtubeLink = "http://youtube.com/marvel";
export const pinterestLink = "https://www.pinterest.com/marvelofficial";
